<template>
  <div
    :class="[
      'mega-cele mb40',
      {
        'leader-ship': type == 'megaLeader',
        plr16: extraPadding === 'true',
      },
    ]"
    :style="[isLast && { 'margin-bottom': '80px !important' }]"
  >
    <div class="mb16">
      <div v-if="title" :class="[type == 'megaGrand' ? 'header' : 'title']">
        {{ title }}
      </div>
      <div v-if="subTitle" class="subTitle">{{ subTitle }}</div>
    </div>
    <div
      class="mega1 mt16 mb16 flex-row flex-wrap gap8 justify-content-center"
      v-if="type == 'megaGrand' && textArray.length > 1"
    >
      <span
        v-for="(item, index) in textArray"
        :key="index"
        :class="[{ active: index === currentIndex }]"
        @click.stop="gotoNum(index)"
      >
        {{ item }}
      </span>
    </div>
    <div
      :class="[
        {
          mega1: type == 'megaGrand',
          mega2: type == 'megaRegional',
          mega3: type == 'megaHighlight',
          'pTB20 plr16 info': type == 'megaLeader' && !isVideoCard,
        },
      ]"
    >
      <div class="items" v-if="type == 'megaLeader' && !isVideoCard">
        <div
          v-for="(item, index) in items"
          :key="index"
          :class="{
            item: true,
            active: index === currentIndex,
            prev: index === getPreviousIndex(currentIndex),
            next: index === getNextIndex(currentIndex),
          }"
        >
          <img
            :src="item.image"
            :src-placeholder="getPlaceHolderImg"
            alt="profile img"
          />
        </div>
      </div>

      <div
        :class="[
          {
            bottomClass: type == 'megaLeader' && !isVideoCard,
            pr: type == 'megaRegional',
            'leader-mp4': isVideoCard,
            'transX-0' : (type == 'megaGrand' && items?.length === 1) || type == 'megaHighlight' 
          },
        ]"
        :id="type"
      >
        <Carousel
          :items-to-show="itemsToShow"
          :wrap-around="shouldBeInfinite"
          v-model="currentIndex"
          :transition="1200"
          :autoplay="shouldStartAutoScroll"
          :pause-autoplay-on-hover="true"
        >
          <Slide v-for="(slide, index) in items" :key="index">
            <div class="carousel__item" :style="getStyle()">
              <product-video
                v-if="isVideoCard"
                video-class=""
                placeholder-class="card-img backup-img"
                :src="slide.link"
                type="video/mp4"
                :src-thumbnail="slide.image"
                :autoplay-in-focus="true"
                :src-thumbnail-placeholder="getPlaceHolderImg"
                :intersection-options="{
                  threshold: 1,
                  rootMargin: '0px 0px -50px 0px',
                  root: null,
                }"
              />
              <div v-else>
                <div v-if="type == 'megaLeader'">
                  <p class="fs-22 title pb8">{{ slide.title }}</p>
                  <p class="fs-14 subtitle pb8">
                    {{ slide.subTitle }}
                  </p>
                  <p class="fs-12 info pb8">
                    {{ slide.info }}
                  </p>
                </div>
                <div
                  v-else
                  :class="[
                    'pr',
                    {
                      t1: !slide.image,
                    },
                  ]"
                >
                  <lazy-image
                    class=""
                    alt="image"
                    :src="type == 'megaHighlight' ? slide.image : slide"
                    :src-placeholder="getPlaceHolderImg"
                    :intersection-options="{ threshold: 0 }"
                    v-if="
                      (type == 'megaHighlight' && slide.image) ||
                      (type != 'megaHighlight' && slide)
                    "
                  />
                  <div
                    :class="[
                      'flex-column subInfo',
                      {
                        pa: slide.image,
                        'border-gradiant': !slide?.image,
                      },
                    ]"
                    v-if="type === 'megaHighlight'"
                  >
                    <span
                      :class="[
                        'title-light',
                        {
                          'title-dark': !slide.image,
                        },
                      ]"
                      >{{ slide.title }}</span
                    >
                    <span
                      :class="[
                        'subTitle-light',
                        {
                          'subTitle-dark': !slide.image,
                        },
                      ]"
                      >{{ slide.subTitle }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Slide>
          <template #addons>
            <div
              class="button-container flex-row justify-content-between plr16 pa"
              v-if="type == 'megaRegional'"
            >
              <div :class="{ active: currentIndex > 0 }" @click="gotoPrev">
                Previous
              </div>
              <div
                :class="{ active: currentIndex < items.length - 1 }"
                @click="gotoNext"
              >
                Next
              </div>
            </div>
            <Pagination v-else />
          </template>
        </Carousel>
      </div>
    </div>
  </div>
</template>

<script setup>
import LazyImage from "./LazyImage.vue";
</script>
<script>
import { defineComponent, defineAsyncComponent } from "vue";
import { Carousel, Pagination, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import { staticImgBaseUrl } from "../config/apiEndpoints";
import { keyMapsGetter } from "../helpers/storeKeys";

export default defineComponent({
  name: "Autoplay",
  props: ["moduleProps"],
  components: {
    Carousel,
    Slide,
    Pagination,
    ProductVideo: defineAsyncComponent(() => import("./ProductVideo.vue")),
  },
  data: () => ({
    modulePropsData: {},
    currentIndex: 0,
    items: [], // Add more items as needed
    next: 0,
    prev: 0,
    textArray: [],
    dataIs: [],
    type: null,
    extraPadding: false,
    itemsToShow: 1,
    title: "",
    subTitle: "",
    isVideoCard: false,
    elementInViewport: false,
    isPageVisible: true,
    isLast: false,
  }),
  mounted() {
    this.modulePropsData =
      this.moduleProps != null &&
      this.moduleProps != "null" &&
      this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    const {
      type = "",
      extraPadding,
      title = "",
      subTitle = "",
    } = this.modulePropsData;
    this.type = type;
    this.subTitle = subTitle;
    this.title = title;
    this.isLast = this.modulePropsData?.isLast == "true" || false;

    if (type === "megaHighlight") {
      this.itemsToShow = 1.09;
    }
    this.extraPadding = extraPadding;
    // if (this.data.length <= 3) {
    //   //and grater than 1
    //   this.data = new Array(2).fill(this.data).flat();
    // }

    const { data = "", isVideoCard = false } = this.modulePropsData;
    if (!data) {
      return;
    }
    this.dataIs = JSON.parse(data) || [];
    this.isVideoCard = isVideoCard === "true";

    if (type === "megaGrand") {
      this.items = Object.values(this.dataIs);
      this.textArray = Object.keys(this.dataIs);
    } else {
      this.items = this.dataIs?.length ? this.dataIs : [];
    }

    if (type === "megaLeader") {
      this.prev = this.items.length - 1;
      this.next = 1;
    }

    if (type == "megaGrand" && this.items.length > 1) {
      const context = this;
      setTimeout(() => {
        const tester = document.getElementById("megaGrand");
        this.handler(context);
        window.addEventListener("scroll", () => this.handler(context, tester));
      }, 1000);

      document.addEventListener(
        "visibilitychange",
        this.handleVisibilityChange
      );
    }
  },
  unmounted() {
    if (this.type == "megaGrand" && this.items.length > 1) {
      window.removeEventListener("scroll", this.handler);
      document.removeEventListener(
        "visibilitychange",
        this.handleVisibilityChange
      );
    }
  },
  methods: {
    gotoPrev() {
      if (this.type === "megaRegional" && this.currentIndex === 0) {
        return;
      }
      this.currentIndex > 0
        ? this.gotoNum(this.currentIndex - 1)
        : this.gotoNum(this.items.length - 1);
    },
    gotoNext() {
      if (
        this.type === "megaRegional" &&
        this.currentIndex === this.items.length - 1
      ) {
        return;
      }
      this.currentIndex < this.items.length - 1
        ? this.gotoNum(this.currentIndex + 1)
        : this.gotoNum(0);
    },
    gotoNum(number, flag = false) {
      this.currentIndex = number;
      this.prev = this.currentIndex - 1;
      this.next = this.currentIndex + 1;

      if (this.next == this.items.length) {
        this.next = 0;
      }

      if (this.prev == -1) {
        this.prev = this.items.length - 1;
      }
    },
    getPreviousIndex(current) {
      let pre = current - 1;
      if (pre == -1) {
        pre = this.items.length - 1;
      }
      return pre;
    },
    getNextIndex(current) {
      let next = current + 1;
      if (next == this.items.length) {
        next = 0;
      }
      return next;
    },
    getBackgroundImage(slide) {
      const { background = "" } = slide;
      let backgroundImageCss = "";
      if (background !== undefined && background) {
        backgroundImageCss = `
          background-image: url('${background}');
          background-repeat: no-repeat;
          background-size: cover;
        `;
      }
      return backgroundImageCss;
    },
    getStyle() {
      if (!this.isVideoCard) {
        return;
      }
      let width = window.innerWidth - 32;
      let _ = {
        width: width + "px !important",
      };
      return _;
    },
    isElementInViewport(el) {
      const scroll = window.scrollY || window.pageYOffset;
      const boundsTop = el.getBoundingClientRect().top + scroll;

      const viewport = {
        top: scroll,
        bottom: scroll + window.innerHeight,
      };

      const bounds = {
        top: boundsTop,
        bottom: boundsTop + el.clientHeight,
      };

      return (
        (bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom) ||
        (bounds.top <= viewport.bottom && bounds.top >= viewport.top)
      );
    },
    handler(context = this, tester = null) {
      if (!tester) {
        return;
      }
      if (context.isElementInViewport(tester)) {
        context.elementInViewport = true;
      } else {
        context.elementInViewport = false;
      }
    },
    handleVisibilityChange() {
      if (document.hidden) {
        this.isPageVisible = false;
      } else {
        this.isPageVisible = true;
      }
    },
  },
  computed: {
    getPlaceHolderImg() {
      const img =
        this.$store.getters[keyMapsGetter.GET_PLACE_HOLDER_IMAGE]?.rect;
      const fallBack =
        staticImgBaseUrl + "/images/global/default-product-img-lg.png";
      return img || fallBack;
    },
    shouldStartAutoScroll() {
      if (
        this.items.length > 1 &&
        this.type === "megaGrand" &&
        this.elementInViewport &&
        this.isPageVisible
      ) {
        return 4000;
      } else {
        return 0;
      }
    },
    shouldBeInfinite() {
      if (this.type === "megaHighlight" || this.type === "megaRegional") {
        return false;
      } else {
        return true;
      }
    },
  },
});
</script>
